import type { HTMLAttributes, ReactNode } from 'react';
import { cn } from '../lib/cn';
import './Banner.css';

export type BannerTone = 'info' | 'brand' | 'amber' | 'coral' | 'neutral';

export interface BannerProps extends Omit<HTMLAttributes<HTMLDivElement>, 'title'> {
  tone?: BannerTone;
  /** Título curto em destaque (opcional). */
  title?: ReactNode;
  /** Ícone/elemento à esquerda. */
  icon?: ReactNode;
  /** Ações à direita (ex.: botão "Saiba mais"). */
  actions?: ReactNode;
}

/**
 * Faixa informativa/instrução (NÃO crítica). Para avisos críticos
 * (vermelho/negrito/sublinhado) use <Alert variant="critical">.
 */
export function Banner({
  tone = 'info',
  title,
  icon,
  actions,
  className,
  children,
  ...rest
}: BannerProps): JSX.Element {
  return (
    <div className={cn('cf-banner', `cf-banner--${tone}`, className)} {...rest}>
      {icon && (
        <span className="cf-banner__icon" aria-hidden="true">
          {icon}
        </span>
      )}
      <div className="cf-banner__body">
        {title && <div className="cf-banner__title">{title}</div>}
        {children && <div className="cf-banner__text">{children}</div>}
      </div>
      {actions && <div className="cf-banner__actions">{actions}</div>}
    </div>
  );
}
